import { z } from 'zod'

import { UserNewZ } from '@/types/userNew'

import { ExpenseModelZ, UserLightZ } from './expense'
import { ExpenseResponseUnionZ } from './unions'

const ExpenseReportStatusZ = z.enum(['draft', 'submitted', 'approved', 'reimbursed', 'rejected'])
export type ExpenseReportStatus = z.infer<typeof ExpenseReportStatusZ>

const ExpenseReportRejectReasonZ = z.strictObject({
	reason: z.string(),
	rejecter: UserLightZ,
	id: z.number(),
	createdAt: z.date(),
})
export type ExpenseReportRejectReason = z.infer<typeof ExpenseReportRejectReasonZ>

const ReportRejectReasonResponseZ = z.strictObject({
	...ExpenseReportRejectReasonZ.omit({ createdAt: true }).shape,
	created_dt: z.iso.datetime({ offset: true }),
})

export const ExpenseReportModelZ = z.strictObject({
	id: z.number(),
	name: z.string(),
	status: ExpenseReportStatusZ,
	expenses: z.array(z.any()),
	submitter: z.any(),
	createdAt: z.date(),
	approver: UserLightZ.nullish(),
	reasons: z.array(ExpenseReportRejectReasonZ),
	dates: z.tuple([z.date(), z.date()]).nullish(),
	description: z.string().nullish(),
	modifiedAt: z.date().nullish(),
	modifiedStatusAt: z.date().nullish(),
})
export type ExpenseReportModel = z.infer<typeof ExpenseReportModelZ>

const ExpenseReportResponseZ = z.strictObject({
	...ExpenseReportModelZ.pick({ id: true, name: true, status: true, approver: true, description: true }).shape,
	expenses: z.array(ExpenseResponseUnionZ),
	submitter: UserNewZ.optional(),
	submitter_id: z.number(),
	created_dt: z.iso.date(),
	reasons: z.array(ReportRejectReasonResponseZ).optional(),
	start_date: z.iso.date().optional(),
	end_date: z.iso.date().optional(),
	last_modified_dt: z.string().nullish(),
	last_status_modified_dt: z.string().nullish(),
})
export type ExpenseReportResponse = z.infer<typeof ExpenseReportResponseZ>

export const ExpenseReportRequestZ = z.strictObject({
	...ExpenseReportResponseZ.pick({ name: true, description: true, start_date: true, end_date: true }).shape,
	expenses: z.array(ExpenseModelZ.shape.id),
})
export type ExpenseReportRequest = z.infer<typeof ExpenseReportRequestZ>
